<script setup lang="ts">
defineOptions({ inheritAttrs: false });
defineProps<{ labelText: string }>();
</script>
<template>
  <MpText class="mp-label" :modelValue="labelText" v-bind="$attrs" />
</template>
